<template>
    <form v-on:submit.prevent="editCropTip">
        <div class="modal-card">
            <header class="modal-card-head" style="background:#222">
                <p class="modal-card-title" style="color:white"><span style="color: #7cda24">Edit</span> {{equipmentType.cropName}}</p>
            </header>
            <section class="modal-card-body">
                <b-field label="Crop Name">
                    <b-input
                        type="text"
                        v-model="equipmentType.cropName"
                        placeholder disabled
                        >
                    </b-input>
                </b-field>

                <b-field label="Crop Trade Name">
                  <b-input v-model="equipmentType.cropTradeName" placeholder disabled ></b-input>
                </b-field>
                <b-field label="Number Of Days">
                  <b-input v-model="equipmentType.days" placeholder="10,12,13"></b-input>
                </b-field>
                <b-field label="Crop Tip">
                  <b-input type="textarea" v-model="equipmentType.tip"></b-input>
                </b-field>

            </section>
            <footer class="modal-card-foot">
                <button class="button is-primary is-outlined" type="submit">Save Changes</button>
                <button class="button is-dark" type="button" @click="$parent.close">Close</button>
            </footer>
        </div>
    </form>
</template>

<script>
import { ucFirst, currencies, ls } from '@/helpers';
import { mapGetters } from 'vuex';
import decode from 'jwt-decode'

export default {
    name: "EditEquipmentTypeModal",
    data() {
        return {
        }
    },
    props: ['equipmentType'],
    computed: {
        userAuth() {
          return ls('token') ? decode(ls('token')) : null;
        },
        isAdmin() {
          return this.userAuth ? this.userAuth.subject === "admin" : false;
        },
        isProvincialManager() {
          return this.userAuth ? this.userAuth.type === "provincial-manager" : false;
        },
    },
    created() {
    },
    methods: {
        editCropTip() {
          const loading = this.$loading.open();
          this.$store.dispatch('editCropTip', this.equipmentType).then(() => {
            console.log(this.equipmentType)
            loading.close();
            this.$parent.close();
            this.$toasted.global.success(`Crop Tip Edited Successfully!`);
            this.$emit('reload');
          }).catch(e=> {
            loading.close();
            console.log('Exception when editing product',e);
            this.$toasted.global.error('Failed to save changes. Please try again.');
          })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/CropManager/EditCropTipModal.vue